// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/profile.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Account_wrapper__Q6qd1 .Account_container__Q2IGr {
  padding-top: 124px;
}
.Account_wrapper__Q6qd1 .Account_container__Q2IGr .Account_title__zxIyf {
  font-size: 48px;
  font-weight: 700;
  font-style: normal;
  color: #ffffff;
}
.Account_wrapper__Q6qd1 .Account_container__Q2IGr .Account_account__ZwcYN {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 8px;
  padding: 16px 21px;
}
.Account_wrapper__Q6qd1 .Account_container__Q2IGr .Account_account__ZwcYN .Account_mobEdit__QLw2B {
  display: none;
}
.Account_wrapper__Q6qd1 .Account_container__Q2IGr .Account_account__ZwcYN .Account_header__wmTW0 {
  align-items: center;
  border-bottom: 1px solid rgba(220, 220, 220, 0.1019607843);
  display: flex;
  justify-content: space-between;
  padding-bottom: 22px;
}
.Account_wrapper__Q6qd1 .Account_container__Q2IGr .Account_account__ZwcYN .Account_header__wmTW0 .Account_headerLeft__0dTU2 {
  font-size: 24px;
  font-weight: 700;
  font-style: normal;
  align-items: center;
  color: #ffffff;
  display: flex;
  gap: 8px;
}
.Account_wrapper__Q6qd1 .Account_container__Q2IGr .Account_account__ZwcYN .Account_header__wmTW0 .Account_headerRight__vWWk\\+ {
  align-items: center;
  background-color: #333217;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  height: 40px;
  transition: all 0.2s linear;
  width: 40px;
}
.Account_wrapper__Q6qd1 .Account_container__Q2IGr .Account_account__ZwcYN .Account_header__wmTW0 .Account_headerRight__vWWk\\+:hover {
  background-color: #494711;
}
.Account_wrapper__Q6qd1 .Account_container__Q2IGr .Account_account__ZwcYN .Account_main__DYMlk {
  align-items: center;
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  margin-top: 20px;
}
.Account_wrapper__Q6qd1 .Account_container__Q2IGr .Account_account__ZwcYN .Account_main__DYMlk .Account_profileImg__mhZrh {
  width: 68px;
}
.Account_wrapper__Q6qd1 .Account_container__Q2IGr .Account_account__ZwcYN .Account_main__DYMlk .Account_name__olv1K {
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  align-items: center;
  color: #ffffff;
  display: flex;
  gap: 5px;
}
.Account_wrapper__Q6qd1 .Account_container__Q2IGr .Account_account__ZwcYN .Account_main__DYMlk .Account_name__olv1K .Account_id__oMX1V {
  color: #E0E0E0;
  font-weight: 400;
}
.Account_wrapper__Q6qd1 .Account_container__Q2IGr .Account_account__ZwcYN .Account_main__DYMlk .Account_name__olv1K .Account_copy__u8bob {
  cursor: pointer;
}
.Account_wrapper__Q6qd1 .Account_container__Q2IGr .Account_account__ZwcYN .Account_main__DYMlk .Account_address__LbSUg {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  color: #E0E0E0;
  margin-top: 8px;
}
.Account_wrapper__Q6qd1 .Account_container__Q2IGr .Account_account__ZwcYN .Account_info__hTKA7 {
  display: flex;
  gap: 80px;
}
.Account_wrapper__Q6qd1 .Account_container__Q2IGr .Account_account__ZwcYN .Account_info__hTKA7 .Account_infoItem__fWe5I {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  color: #E0E0E0;
  display: flex;
  gap: 8px;
}
.Account_wrapper__Q6qd1 .Account_container__Q2IGr .Account_account__ZwcYN .Account_info__hTKA7 .Account_infoItem__fWe5I .Account_steam__w1bc9 {
  display: flex;
  gap: 4px;
  margin-bottom: 8px;
}
.Account_wrapper__Q6qd1 .Account_container__Q2IGr .Account_account__ZwcYN .Account_info__hTKA7 .Account_infoItem__fWe5I .Account_steam__w1bc9 .Account_copy__u8bob {
  cursor: pointer;
}

@media (max-width: 850px) {
  .Account_wrapper__Q6qd1 .Account_container__Q2IGr {
    padding-top: 104px;
  }
  .Account_wrapper__Q6qd1 .Account_container__Q2IGr .Account_title__zxIyf {
    font-size: 32px;
    font-weight: 700;
    font-style: normal;
  }
  .Account_wrapper__Q6qd1 .Account_container__Q2IGr .Account_account__ZwcYN .Account_mobEdit__QLw2B {
    display: flex;
    justify-content: end;
    margin-bottom: 12px;
  }
  .Account_wrapper__Q6qd1 .Account_container__Q2IGr .Account_account__ZwcYN .Account_header__wmTW0 .Account_headerLeft__0dTU2 {
    font-size: 20px;
    font-weight: 700;
    font-style: normal;
  }
  .Account_wrapper__Q6qd1 .Account_container__Q2IGr .Account_account__ZwcYN .Account_main__DYMlk .Account_profileImg__mhZrh {
    width: 64px;
  }
  .Account_wrapper__Q6qd1 .Account_container__Q2IGr .Account_account__ZwcYN .Account_main__DYMlk .Account_name__olv1K {
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
  }
  .Account_wrapper__Q6qd1 .Account_container__Q2IGr .Account_account__ZwcYN .Account_info__hTKA7 {
    display: block;
    margin-top: 24px;
  }
  .Account_wrapper__Q6qd1 .Account_container__Q2IGr .Account_account__ZwcYN .Account_info__hTKA7 .Account_infoItem__fWe5I {
    font-size: 16px;
    font-weight: 400;
    font-style: normal;
    margin-bottom: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Account/Account.module.scss","webpack://./src/assets/styles/_fonts.scss"],"names":[],"mappings":"AAIE;EACE,kBAAA;AAHJ;AAKI;ECAF,eAAA;EACA,gBAAA;EACA,kBAAA;EDCI,cAAA;AAFN;AAKI;EACE,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AAHN;AAKM;EACE,aAAA;AAHR;AAMM;EACE,mBAAA;EACA,0DAAA;EACA,aAAA;EACA,8BAAA;EACA,oBAAA;AAJR;AAMQ;ECZN,eAAA;EACA,gBAAA;EACA,kBAAA;EDaQ,mBAAA;EACA,cAAA;EACA,aAAA;EACA,QAAA;AAHV;AAMQ;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,2BAAA;EACA,WAAA;AAJV;AAMU;EACE,yBAAA;AAJZ;AASM;EACE,mBAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AAPR;AASQ;EACE,WAAA;AAPV;AAUQ;EC9BN,eAAA;EACA,gBAAA;EACA,kBAAA;ED+BQ,mBAAA;EACA,cAAA;EACA,aAAA;EACA,QAAA;AAPV;AASU;EACE,cAAA;EACA,gBAAA;AAPZ;AAUU;EACE,eAAA;AARZ;AAYQ;ECxBN,eAAA;EACA,gBAAA;EACA,kBAAA;EDyBQ,cAAA;EACA,eAAA;AATV;AAaM;EACE,aAAA;EACA,SAAA;AAXR;AAaQ;ECtDN,eAAA;EACA,gBAAA;EACA,kBAAA;EDuDQ,cAAA;EACA,aAAA;EACA,QAAA;AAVV;AAYU;EACE,aAAA;EACA,QAAA;EACA,kBAAA;AAVZ;AAYY;EACE,eAAA;AAVd;;AAmBA;EAGI;IACE,kBAAA;EAlBJ;EAoBI;IChHJ,eAAA;IACA,gBAAA;IACA,kBAAA;ED+FA;EAqBM;IACE,aAAA;IACA,oBAAA;IACA,mBAAA;EAnBR;EAwBQ;IC5GR,eAAA;IACA,gBAAA;IACA,kBAAA;EDuFA;EAyBQ;IACE,WAAA;EAvBV;EA0BQ;ICpGR,eAAA;IACA,gBAAA;IACA,kBAAA;ED6EA;EA0BM;IACE,cAAA;IACA,gBAAA;EAxBR;EA0BQ;ICjGR,eAAA;IACA,gBAAA;IACA,kBAAA;IDkGU,mBAAA;EAvBV;AACF","sourcesContent":["@import '../../assets/styles/global.scss';\n\n.wrapper {\n\n  .container {\n    padding-top: 124px;\n\n    .title {\n      @include h2;\n\n      color: #ffffff;\n    }\n\n    .account {\n      background-image: url('../../assets/images/profile.png');\n      background-repeat: no-repeat;\n      background-size: cover;\n      border-radius: 8px;\n      padding: 16px 21px;\n\n      .mobEdit {\n        display: none;\n      }\n\n      .header {\n        align-items: center;\n        border-bottom: 1px solid #DCDCDC1A;\n        display: flex;\n        justify-content: space-between;\n        padding-bottom: 22px;\n\n        .headerLeft {\n          @include subtitle1b;\n\n          align-items: center;\n          color: #ffffff;\n          display: flex;\n          gap: 8px;\n        }\n\n        .headerRight {\n          align-items: center;\n          background-color: #333217;\n          border-radius: 8px;\n          display: flex;\n          justify-content: center;\n          height: 40px;\n          transition: all .2s linear;\n          width: 40px;\n\n          &:hover {\n            background-color: #494711;\n          }\n        }\n      }\n\n      .main {\n        align-items: center;\n        display: flex;\n        gap: 12px;\n        margin-bottom: 24px;\n        margin-top: 20px;\n\n        .profileImg {\n          width: 68px;\n        }\n\n        .name {\n          @include subtitle4m;\n\n          align-items: center;\n          color: #ffffff;\n          display: flex;\n          gap: 5px;\n\n          .id {\n            color: #E0E0E0;\n            font-weight: 400;\n          }\n\n          .copy {\n            cursor: pointer;\n          }\n        }\n\n        .address {\n          @include body1;\n\n          color: #E0E0E0;\n          margin-top: 8px;\n        }\n      }\n\n      .info {\n        display: flex;\n        gap: 80px;\n\n        .infoItem {\n          @include subtitle5;\n\n          color: #E0E0E0;\n          display: flex;\n          gap: 8px;\n\n          .steam {\n            display: flex;\n            gap: 4px;\n            margin-bottom: 8px;\n\n            .copy {\n              cursor: pointer;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 850px) {\n  .wrapper {\n\n    .container {\n      padding-top: 104px;\n\n      .title {\n        @include h3;\n      }\n\n      .account {\n\n        .mobEdit {\n          display: flex;\n          justify-content: end;\n          margin-bottom: 12px;\n        }\n\n        .header {\n\n          .headerLeft {\n            @include subtitle3b;\n          }\n        }\n\n        .main {\n          .profileImg {\n            width: 64px;\n          }\n\n          .name {\n            @include subtitle6m;\n          }\n        }\n\n        .info {\n          display: block;\n          margin-top: 24px;\n\n          .infoItem {\n            @include body1;\n\n            margin-bottom: 12px;\n          }\n        }\n      }\n    }\n  }\n}","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Account_wrapper__Q6qd1`,
	"container": `Account_container__Q2IGr`,
	"title": `Account_title__zxIyf`,
	"account": `Account_account__ZwcYN`,
	"mobEdit": `Account_mobEdit__QLw2B`,
	"header": `Account_header__wmTW0`,
	"headerLeft": `Account_headerLeft__0dTU2`,
	"headerRight": `Account_headerRight__vWWk+`,
	"main": `Account_main__DYMlk`,
	"profileImg": `Account_profileImg__mhZrh`,
	"name": `Account_name__olv1K`,
	"id": `Account_id__oMX1V`,
	"copy": `Account_copy__u8bob`,
	"address": `Account_address__LbSUg`,
	"info": `Account_info__hTKA7`,
	"infoItem": `Account_infoItem__fWe5I`,
	"steam": `Account_steam__w1bc9`
};
export default ___CSS_LOADER_EXPORT___;
